import { createSlice } from "@reduxjs/toolkit";
import { getLeaderBoard } from './thunk';
export const initialState = {
  course: {},
  currentUser: {},  
  users: [],
  error: {}
};

const Common = createSlice({
  name: 'Common',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getLeaderBoard.fulfilled, (state, action) => {
      state.course = action.payload.Course;
      state.currentUser = action.payload.CurrentUser || {};
      state.users = action.payload.Users
    });

    builder.addCase(getLeaderBoard.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Common.reducer;